import { render, staticRenderFns } from "./ProductCardsLocal.vue?vue&type=template&id=0b4ce423&"
import script from "./ProductCardsLocal.vue?vue&type=script&lang=js&"
export * from "./ProductCardsLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports